import { render, staticRenderFns } from "./answerEnd.vue?vue&type=template&id=410a423e&scoped=true"
import script from "./answerEnd.vue?vue&type=script&lang=js"
export * from "./answerEnd.vue?vue&type=script&lang=js"
import style0 from "./answerEnd.vue?vue&type=style&index=0&id=410a423e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a423e",
  null
  
)

export default component.exports